import * as types from './constants';

// Get Performance Exports
export const getPerformanceExportsRequest = data => (
  { type: types.GET_PERFORMANCE_EXPORTS_REQUEST, payload: data }
);

export const getPerformanceExportsDone = data => (
  { type: types.GET_PERFORMANCE_EXPORTS_DONE, payload: data }
);

export const getPerformanceExportsFailed = errors => (
  { type: types.GET_PERFORMANCE_EXPORTS_FAILED, payload: errors }
);

// Operations
export const updateUserPerformanceExports = data => (
  { type: types.UPDATE_USER_PERFORMANCE_EXPORTS, payload: data }
);

export const togglePerformanceExports = data => (
  { type: types.TOGGLE_PERFORMANCE_EXPORTS, payload: data }
);

export const toggleAllPerformanceExports = data => (
  { type: types.TOGGLE_ALL_PERFORMANCE_EXPORTS, payload: data }
);

export const setFilter = data => (
  { type: types.SET_PERFORMANCE_EXPORTS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_PERFORMANCE_EXPORTS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_PERFORMANCE_EXPORTS_FILTERS, payload: { filterToUpdate, mobile } }
);

export const performanceExportsSetPage = data => (
  { type: types.PERFORMANCE_EXPORTS_SET_PAGE, payload: data }
);